import React from "react"
import cn from "classnames"

interface DataGroupProps {
  title: string
  children: React.ReactNode
  className?: string
  themeColor?: string
}

const DataGroup = ({
  title,
  children,
  className = "",
  themeColor = "blue-500",
}: DataGroupProps) => (
  <div className={cn("w-full flex flex-col gap-1 mb-4", className)}>
    <div className="flex flex-row items-center gap-2 ml-1 mb-1">
      <div className={cn("w-1 h-3 rounded-full", `bg-${themeColor}`)} />
      <h3 className="text-[11px] font-bold text-gray-400 uppercase tracking-widest">{title}</h3>
    </div>
    <div className="w-full bg-white rounded-2xl overflow-hidden border border-gray-200 shadow-sm">
      <div className="flex flex-col">{children}</div>
    </div>
  </div>
)

export default DataGroup
